<template>
    <div>
        <section class="section-title-page container-fluid" style="background-image: url('/img/bg_tramite.jpg');">
            <div class="container">
                <div class="wrapper">
                    <h1>Trámites <small style="font-weight: 300;">a tu disposición</small></h1>
                    <span>
                        Volver <i class="fa fa-angle-right mx-1"></i>
                        <a href="/">Inicio</a>
                    </span>
                </div>
            </div>
        </section>

        <section class="section-page container-fluid">
            <div class="container">
                <div class="section-info">
                    <p class="m-0"><i class="fa-solid fa-circle mr-2"></i>En esta sección podrás conocer los requisitos de diversos
                        trámites administrativos. Para visualizar, <strong>haz clic</strong> en el trámite que desees.</p>
                </div>
            </div>
            <div class="services container">
                <div class="all-process">
                    <div v-for="(value, key) in ListaTramites" :key="key" class="col-md-3">
                        <div class="featured-box featured-box-primary featured-box-effect-3">
                            <a :href="'/tramite/' + value.id" class="box-content">
                                <span>
                                    <i :class="['fa-solid', value.icono]"></i>
                                </span>
                                <h4 class="pt-4 text-black font-weight-light">
                                    {{ value.titulo }} <br />
                                    <strong style="font-weight: 900">{{ value.subtitulo }}</strong>
                                </h4>
                                <p class="text-black font-weight-light">{{ value.descripcion }}</p>
                                <i class="fa-solid fa-circle-chevron-right"></i>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';

export default {
    name: 'tramites',
    computed: {
        ...mapState(['empresa']),
    },
    created() {
    },
    mounted() {
        this.getTramites();
        document.title = "Trámites | " + ((this.empresa.abreviatura) ? this.empresa.abreviatura : "-");
    },
    data() {
        return {
            ListaTramites: []
        }
    },
    methods: {
        ...mapMutations(['setLoading']),
        getTramites() {
            this.setLoading(true);
            this.$http.get('ws_principal/process').then((res) => {
                this.ListaTramites = res.data.Tramites;
                this.setLoading(false);
            });
        },
    },
}
</script>